import { useState } from "react";
import saveIcon from "../assets/save-icon.svg";

const familyHistoryOptions = ["SELF", "FAMILY", "BOTH SELF AND FAMILY", "NONE"];

const SelectField = ({ label, value, onChange }) => (
  <div className="relative w-full min-w-0 box-border h-[90px] xl:h-[52px] 2xl:h-[52px] 3xl:h-[52px] rounded-[42px] border border-solid border-[#D9D9D9] bg-transparent">
    <select
      value={value ?? ""}
      onChange={(e) => onChange(e.target.value)}
      className="absolute inset-0 w-full h-full pl-[32px] pr-[120px] bg-transparent border-none outline-none focus:outline-none focus:ring-0 appearance-none cursor-pointer font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B]"
    >
      <option value="" disabled hidden>
        {label}
      </option>
      {familyHistoryOptions.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
    {value && (
      <span className="absolute right-[45px] top-1/2 -translate-y-1/2 font-lufga font-normal text-[12px] leading-[12px] tracking-[-0.03em] text-[#8B8B8B] pointer-events-none">
        {label}
      </span>
    )}
    <div className="absolute right-[14px] top-1/2 -translate-y-1/2 pointer-events-none">
      <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path
          d="M7 10.5L14 17.5L21 10.5"
          stroke="#5AC69F"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  </div>
);

const FamilyHistoryFormAi = () => {
  const [formData, setFormData] = useState({
    diabetes: null,
    hypertension: null,
    heartDieses: null,
    stroke: null,
    cancer: null,
    tuberculosis: null,
    asthma: null,
  });

  const handleChange = (field) => (value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      <div className="grid grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-3 pt-[30px]">
        <SelectField
          label="Diabetes"
          value={formData.diabetes}
          onChange={handleChange("diabetes")}
        />
        <SelectField
          label="Hypertension"
          value={formData.hypertension}
          onChange={handleChange("hypertension")}
        />
        <SelectField
          label="Heart Disease"
          value={formData.heartDieses}
          onChange={handleChange("heartDieses")}
        />
        <SelectField
          label="Stroke"
          value={formData.stroke}
          onChange={handleChange("stroke")}
        />
        <SelectField
          label="Cancer"
          value={formData.cancer}
          onChange={handleChange("cancer")}
        />
        <SelectField
          label="Tuberculosis"
          value={formData.tuberculosis}
          onChange={handleChange("tuberculosis")}
        />
        <SelectField
          label="Asthma"
          value={formData.asthma}
          onChange={handleChange("asthma")}
        />
      </div>
      <div className="flex justify-end mt-[12px]">
        <button className="w-[170px] h-[74px] xl:w-[94.97px] xl:h-[40.97px]  2xl:w-[94.97px] 2xl:h-[40.97px] border border-none rounded-full bg-black flex justify-center items-center gap-[8px] font-lufga text-[14px] text-[#68FF9F] font-normal">
          SAVE
          <img src={saveIcon} alt="save" className="pl-[16px]" />
        </button>
      </div>
    </div>
  );
};

export default FamilyHistoryFormAi;
